import { supabase } from '@/lib/supabaseClient';
import type { Session } from '@supabase/supabase-js';

export async function ensureAuthenticatedSession(): Promise<Session> {
  const { data, error } = await supabase.auth.getSession();

  if (error) {
    throw new Error(error.message || 'No se pudo validar la sesión del usuario.');
  }

  if (!data.session) {
    throw new Error('El usuario debe iniciar sesión para realizar esta acción.');
  }

  return data.session;
}

